<mapfre-header [isGuest]="true"></mapfre-header>
<div class="container mapfre-content">
  <div class="ie-message" *ngIf="isIEBrowser">
    <mapfre-info-divs [additionDivClass]="'align-icon-bop'">
      <em>{{ "Internet Explorer is no longer supported." | translate }}</em
      ><br />
      <em>
        {{
          "Please use Chrome, Firefox, Safari, or Microsoft Edge for a better experience."
        }}</em
      >
    </mapfre-info-divs>
  </div>
  <mapfre-card additionalClasses="signup guest-payment-container">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon full-icon">
          <ng-container *ngIf="isAcmic; else MAStateCompensation">
            <svg-mailing-svg></svg-mailing-svg>
          </ng-container>
          <ng-template #MAStateCompensation>
            <img src="./assets/img/images/icon-compensation.svg" width="64px" height="64px" alt="compensation icon" />
          </ng-template>
        </div>
        <h1 class="title-copy">{{ "MAKE_A_PAYMENT_GUEST" | translate }}</h1>
      </div>
    </div>
    <app-make-payment-form [inputs]="inputs"></app-make-payment-form>
  </mapfre-card>
</div>
